import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
export default function UpdateStaffForm() {
  const navigate = useNavigate();

  return (
      <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="container-fluid mt-4">
    <div className="container mt-5">
      <div className="card shadow p-4 rounded-4">
        <h4 className="text-center text-primary fw-bold mb-4">
          Update Staff Details
        </h4>

        {/* Staff Basic Details */}
        <h5 className="mb-3">Staff Basic Details</h5>
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label">Session</label>
            <input
              type="text"
              className="form-control"
              defaultValue="2024-2025"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Staff ID*</label>
            <input type="text" className="form-control" />
          </div>
          <div className="col-md-4">
            <label className="form-label">Staff Name*</label>
            <input type="text" className="form-control" />
          </div>

          <div className="col-md-4">
            <label className="form-label">Mobile No*</label>
            <input type="text" className="form-control" />
          </div>
          <div className="col-md-4">
            <label className="form-label">Secondary Mobile No</label>
            <input type="text" className="form-control" />
          </div>
          <div className="col-md-4">
            <label className="form-label">Father's Name</label>
            <input type="text" className="form-control" />
          </div>

          <div className="col-md-4">
            <label className="form-label">Email</label>
            <input type="email" className="form-control" />
          </div>
          <div className="col-md-4">
            <label className="form-label">Gender*</label>
            <select className="form-select">
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">DOB</label>
            <input type="date" className="form-control" />
          </div>

          <div className="col-md-4">
            <label className="form-label">Aadhar</label>
            <input type="text" className="form-control" />
          </div>
          <div className="col-md-4">
            <label className="form-label">Referred By</label>
            <input type="text" className="form-control" />
          </div>
          <div className="col-md-4">
            <label className="form-label">Staff Image</label>
            <input type="file" className="form-control" />
          </div>
        </div>

        {/* Address Details */}
        <h5 className="mt-4 mb-3">Address Details</h5>
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label">Village*</label>
            <input type="text" className="form-control" />
          </div>
          <div className="col-md-4">
            <label className="form-label">Tehsil</label>
            <input type="text" className="form-control" />
          </div>
          <div className="col-md-4">
            <label className="form-label">State*</label>
            <input
              type="text"
              className="form-control"
              defaultValue="Rajasthan"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">District*</label>
            <input type="text" className="form-control" defaultValue="Sikar" />
          </div>
          <div className="col-md-4">
            <label className="form-label">PinCode</label>
            <input type="text" className="form-control" />
          </div>
        </div>

        {/* Educational Details */}
        <h5 className="mt-4 mb-3">Educational Details</h5>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Education</label>
            <input type="text" className="form-control" />
          </div>
          <div className="col-md-6">
            <label className="form-label">School Name</label>
            <input type="text" className="form-control" />
          </div>
        </div>

        {/* Additional Details */}
        <h5 className="mt-4 mb-3">Additional Details</h5>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Type*</label>
            <select className="form-select">
              <option>Select Type</option>
              <option>Teacher</option>
              <option>Clerk</option>
              <option>Peon</option>
            </select>
          </div>
          <div className="col-md-6">
            <label className="form-label">Salary (Per Month)*</label>
            <input type="number" className="form-control" />
          </div>
          <div className="col-12">
            <label className="form-label">Remark</label>
            <textarea className="form-control" rows="2"></textarea>
          </div>
        </div>

        {/* Submit */}
        <div className="text-end mt-4">
          <button className="btn btn-danger mx-5" onClick={() => navigate(-1)}>
            cancel
          </button>
          <button className="btn btn-primary px-4">Update Staff</button>
        </div>
      </div>
    </div></div></div></div></div>
  );
}
